import { AppSettings } from "@/AppSettings";
import { styled, Typography } from "@mui/material";
import { CrfForm, ICrfFormProps, IForm } from "@ngt/opms";


const StyledDialogTitle = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(2),
    fontSize: '1.25rem',
    fontWeight: 500
}));

type OmitCalculatedTypes<T> = Omit<T, 'onValidate' | 'allowSubmit' | 'initialValues' | 'lookups' | 'labels'>

export interface ICrfDialogFormProps<Type extends IForm> extends OmitCalculatedTypes<ICrfFormProps<Type>> {
    dialogTitle?: string;
    hideButtons?: boolean;
    hideSubmit?: boolean;
    hideCancel?: boolean;
}

export const CrfDialogForm = <Type extends IForm>({
    dialogTitle,
    children,
    ...formProps
}: ICrfDialogFormProps<Type>) => {
    return (
        <CrfForm
            {...formProps}
            debug={AppSettings.debug}
            disableHeading
        >
            <StyledDialogTitle
                color="secondary"
            >
                {dialogTitle ?? formProps.entity}
            </StyledDialogTitle>
            
            {children}
        </CrfForm>
    );
}